export const ORDER_LIST_ACTION = "ORDER_LIST_ACTION";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_DETAIL_ACTION = "ORDER_DETAIL_ACTION";
export const ORDER_DETAIL_SUCCESS = "ORDER_DETAIL_SUCCESS";
export const ORDER_ITEM_GET_ACTION = "ORDER_ITEM_GET_ACTION";
export const ORDER_ITEM_GET_SUCCESS = "ORDER_ITEM_GET_SUCCESS";
export const ORDER_VOUCHER_GET_ITEM_ACTION = "ORDER_VOUCHER_GET_ITEM_ACTION";
export const ORDER_VOUCHER_GET_ITEM_SUCCESS = "ORDER_VOUCHER_GET_ITEM_SUCCESS";
export const ORDER_FLIGHT_GET_ITEM_ACTION = "ORDER_FLIGHT_GET_ITEM_ACTION";
export const ORDER_FLIGHT_GET_ITEM_SUCCESS = "ORDER_FLIGHT_GET_ITEM_SUCCESS";
export const ORDER_HOTEL_GET_BOOKING_ACTION = "ORDER_HOTEL_GET_BOOKING_ACTION";
export const ORDER_HOTEL_GET_BOOKING_SUCCESS = "ORDER_HOTEL_GET_BOOKING_SUCCESS";
export const ORDER_HOMESTAY_GET_BOOKING_ACTION = "ORDER_HOMESTAY_GET_BOOKING_ACTION";
export const ORDER_HOMESTAY_GET_BOOKING_SUCCESS = "ORDER_HOMESTAY_GET_BOOKING_SUCCESS"
export const ORDER_CROSSSELL_GET_BOOKING_ACTION = "ORDER_CROSSSELL_GET_BOOKING_ACTION";
export const ORDER_CROSSSELL_GET_BOOKING_SUCCESS = "ORDER_CROSSSELL_GET_BOOKING_SUCCESS";
export const ORDER_GET_INFO_DETAIL_GROUP_ACTION = "ORDER_GET_INFO_DETAIL_GROUP_ACTION";
export const ORDER_GET_INFO_DETAIL_GROUP_SUCCESS = "ORDER_GET_INFO_DETAIL_GROUP_SUCCESS";
export const ORDER_VOUCHER_GET_DETAIL_VOUCHER_ACTION = "ORDER_VOUCHER_GET_DETAIL_VOUCHER_ACTION";
export const ORDER_VOUCHER_GET_DETAIL_VOUCHER_SUCCESS = "ORDER_VOUCHER_GET_DETAIL_VOUCHER_SUCCESS";
export const ORDER_FAIL = "ORDER_FAIL";
export const ORDER_RESEND_EMAIL_ACTION = "ORDER_RESEND_EMAIL_ACTION";
export const ORDER_RESEND_EMAIL_SUCCESS = "ORDER_RESEND_EMAIL_SUCCESS";

export const ORDER_SEND_EMAIL_TEMPLATE_ACTION = "ORDER_SEND_EMAIL_TEMPLATE_ACTION";
export const ORDER_SEND_EMAIL_TEMPLATE_SUCCESS = "ORDER_SEND_EMAIL_TEMPLATE_SUCCESS";

export const ORDER_EXPORT_EXCEL_ACTION = "ORDER_EXPORT_EXCEL_ACTION";
export const ORDER_EXPORT_SKU_EXCEL_ACTION = "ORDER_EXPORT_SKU_EXCEL_ACTION";
export const ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL_ACTION = "ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL_ACTION";
export const ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL_ACTION = "ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL_ACTION";
export const ORDER_EXPORT_EXCEL_FAIL = "ORDER_EXPORT_EXCEL_FAIL";
export const ORDER_EXPORT_EXCEL_SUCCESS = "ORDER_EXPORT_EXCEL_SUCCESS";

export const ORDER_EXPORT_ACCESS_TRADE_ACTION = "ORDER_EXPORT_ACCESS_TRADE_ACTION";
export const ORDER_EXPORT_ACCESS_TRADE_SUCCESS = "ORDER_EXPORT_ACCESS_TRADE_SUCCESS";

export const ORDER_EXPORT_SALE_ORDER_ACTION = "ORDER_EXPORT_SALE_ORDER_ACTION";
export const ORDER_EXPORT_SALE_ORDER_SUCCESS = "ORDER_EXPORT_SALE_ORDER_SUCCESS";

export const ORDER_EXPORT_TOUR_SALE_ORDER_ACTION = "ORDER_EXPORT_TOUR_SALE_ORDER_ACTION";
export const ORDER_EXPORT_TOUR_SALE_ORDER_SUCCESS = "ORDER_EXPORT_TOUR_SALE_ORDER_SUCCESS";

export const ORDER_UPDATE_ACTION = "ORDER_UPDATE_ACTION";
export const ORDER_UPDATE_SUCCESS = "ORDER_UPDATE_SUCCESS";

export const ORDER_UPDATE_ACCOUNTANT_ACTION = "ORDER_UPDATE_ACCOUNTANT_ACTION";
export const ORDER_UPDATE_ACCOUNTANT_SUCCESS = "ORDER_UPDATE_ACCOUNTANT_SUCCESS";

export const ORDER_FLIGHT_UPDATE_ACTION = "ORDER_FLIGHT_UPDATE_ACTION";
export const ORDER_FLIGHT_UPDATE_SUCCESS = "ORDER_FLIGHT_UPDATE_SUCCESS";

export const ORDER_UPDATE_INVOICE_ACTION = "ORDER_UPDATE_INVOICE_ACTION";
export const ORDER_UPDATE_INVOICE_SUCCESS = "ORDER_UPDATE_INVOICE_SUCCESS";

export const ORDER_EXPORT_VOUCHER_ACTION = "ORDER_EXPORT_VOUCHER_ACTION";

export const ORDER_TOUR_RECOMMIT_ACTION = "ORDER_TOUR_RECOMMIT_ACTION";
export const ORDER_TOUR_RECOMMIT_SUCCESS = "ORDER_TOUR_RECOMMIT_SUCCESS";
export const ORDER_TOUR_RECOMMIT_FAILED = "ORDER_TOUR_RECOMMIT_FAILED";

export const ORDER_TOUR_UPDATE_STATUS_ACTION = "ORDER_TOUR_UPDATE_STATUS_ACTION";
export const ORDER_TOUR_UPDATE_STATUS_SUCCESS = "ORDER_TOUR_UPDATE_STATUS_SUCCESS";
export const ORDER_TOUR_UPDATE_STATUS_FAILED = "ORDER_TOUR_UPDATE_STATUS_FAILED";

export const CHANGE_RATE_CODE_ACTION = "CHANGE_RATE_CODE_ACTION";
export const CHANGE_RATE_CODE_SUCCESS = "CHANGE_RATE_CODE_SUCCESS";
export const ORDER_DETAIL_GOLF_ACTION = "ORDER_DETAIL_GOLF_ACTION";
export const ORDER_FAIL_GOLF = "ORDER_FAIL_GOLF";
export const ORDER_DETAIL_GOLF_SUCCESS = "ORDER_DETAIL_GOLF_SUCCESS";
/* SURCHARGE TYPES */

export const SURCHARGE_OPEN_MODAL = "SURCHARGE_OPEN_MODAL";
export const SURCHARGE_CLOSE_MODAL = "SURCHARGE_CLOSE_MODAL";

export const ORDER_SURCHARGE_GET_ITEM_ACTION = "ORDER_SURCHARGE_GET_ITEM_ACTION";
export const ORDER_SURCHARGE_GET_ITEM_SUCCESS = "ORDER_SURCHARGE_GET_ITEM_SUCCESS"

export const SURCHARGE_ITEM_DETAIL_ACTION = "SURCHARGE_ITEM_DETAIL_ACTION";
export const SURCHARGE_ITEM_DETAIL_DELETE_ACTION = "SURCHARGE_ITEM_DETAIL_DELETE_ACTION";
export const SURCHARGE_ITEM_DETAIL_SUCCESS = "SURCHARGE_ITEM_DETAIL_SUCCESS";
export const SURCHARGE_ITEM_DETAIL_FAIL = "SURCHARGE_ITEM_DETAIL_FAIL"
export const GET_ALL_SURCHARGE_SUCCESS = "GET_ALL_SURCHARGE_SUCCESS"

export const GET_BUNDLE_ORDER_SURCHARGE_ACTION = "GET_BUNDLE_ORDER_SURCHARGE_ACTION"
export const GET_BUNDLE_ORDER_SURCHARGE_SUCCESS = "GET_BUNDLE_ORDER_SURCHARGE_SUCCESS"
export const BUNDLE_ORDER_CREATE_SURCHARGE_ACTION = "BUNDLE_ORDER_CREATE_SURCHARGE_ACTION"
export const BUNDLE_ORDER_CANCEL_SURCHARGE_ACTION = "BUNDLE_ORDER_CANCEL_SURCHARGE_ACTION"

export const SURCHARGE_ITEM_DETAIL_UPDATE_ACTION = "SURCHARGE_ITEM_DETAIL_UPDATE_ACTION";
export const SURCHARGE_ITEM_DETAIL_CREATE_ACTION = "SURCHARGE_ITEM_DETAIL_CREATE_ACTION";

export const ORDER_UPDATE_TOUR_ITEM_ACTION = "ORDER_UPDATE_TOUR_ITEM_ACTION";

export const ORDER_ITEM_UPDATE_STATUS_ACTION = "ORDER_ITEM_UPDATE_STATUS_ACTION";
export const ORDER_ITEM_UPDATE_STATUS_SUCCESS = "ORDER_ITEM_UPDATE_STATUS_SUCCESS";

export const ORDER_ITEM_LOCK_ACTION = "ORDER_ITEM_LOCK_ACTION";
export const ORDER_ITEM_LOCK_SUCCESS = "ORDER_ITEM_LOCK_SUCCESS";

export const ORDER_ITEM_CHECK_REDEEM_ACTION = "ORDER_ITEM_CHECK_REDEEM_ACTION";
export const ORDER_ITEM_CHECK_REDEEM_SUCCESS = "ORDER_ITEM_CHECK_REDEEM_SUCCESS";

export const ORDER_ITEM_REDEEM_ACTION = "ORDER_ITEM_REDEEM_ACTION";
export const ORDER_ITEM_REDEEM_SUCCESS = "ORDER_ITEM_REDEEM_SUCCESS";
export const ORDER_ITEM_REDEEM_FAIL = "ORDER_ITEM_REDEEM_FAIL";

export const GET_ALL_AIRLINE_ACTION = "GET_ALL_AIRLINE_ACTION";
export const GET_ALL_AIRLINE_SUCCESS = "GET_ALL_AIRLINE_SUCCESS";

export const GET_ALL_AIRPORT_ACTION = "GET_ALL_AIRPORT_ACTION";
export const GET_ALL_AIRPORT_SUCCESS = "GET_ALL_AIRPORT_SUCCESS";

export const GET_ALL_ROUTES_ACTION = "GET_ALL_ROUTES_ACTION";
export const GET_ALL_ROUTES_SUCCESS = "GET_ALL_ROUTES_SUCCESS";

export const GET_ALL_VEHICLE_TYPES_ACTION = "GET_ALL_VEHICLE_TYPES_ACTION";
export const GET_ALL_VEHICLE_TYPES_SUCCESS = "GET_ALL_VEHICLE_TYPES_SUCCESS";

export const GET_ALL_VEHICLE_ACTION = "GET_ALL_VEHICLE_ACTION";
export const GET_ALL_VEHICLE_SUCCESS = "GET_ALL_VEHICLE_SUCCESS";

export const ORDER_RECOMMIT_HOTEL_BUNDLE_ACTION = "ORDER_RECOMMIT_HOTEL_BUNDLE_ACTION";
export const ORDER_RECOMMIT_HOTEL_BUNDLE_SUCCESS = "ORDER_RECOMMIT_HOTEL_BUNDLE_SUCCESS";
export const ORDER_RECOMMIT_HOTEL_BUNDLE_FAILED = "ORDER_RECOMMIT_HOTEL_BUNDLE_FAILED";

export const ORDER_PUSH_FIXED_CHARGE_ACTION = "ORDER_PUSH_FIXED_CHARGE_ACTION";
export const ORDER_PUSH_FIXED_CHARGE_SUCCESS = "ORDER_PUSH_FIXED_CHARGE_SUCCESS";
export const ORDER_PUSH_FIXED_CHARGE_FAIL = "ORDER_PUSH_FIXED_CHARGE_FAIL";

export const VINWONDER_CUSTOMERS_GET_LIST_ACTION = "VINWONDER_CUSTOMERS_GET_LIST_ACTION";
export const VINWONDER_CUSTOMERS_GET_LIST_SUCCESS = "VINWONDER_CUSTOMERS_GET_LIST_SUCCESS";

export const SMS_HISTORIES_ACTION = "SMS_HISTORIES_ACTION";
export const SMS_HISTORIES_SUCCESS = "SMS_HISTORIES_SUCCESS";

export const SMS_RESEND_ACTION = "SMS_RESEND_ACTION";
export const SMS_RESEND_SUCCESS = "SMS_RESEND_SUCCESS";

export const UPDATE_PROFILE_ACTION = "UPDATE_PROFILE_ACTION";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";

export const FIXCHARGE_RESEND_ACTION = "FIXCHARGE_RESEND_ACTION";
export const FIXCHARGE_RESEND_SUCCESS  = "FIXCHARGE_RESEND_SUCCESS";

export const CREATE_FLIGHT_TRACKING_ACTION = "CREATE_FLIGHT_TRACKING_ACTION";
export const CREATE_FLIGHT_TRACKING_SUCCESS = "CREATE_FLIGHT_TRACING_SUCCESS";
export const CREATE_FLIGHT_TRACKING_FAIL = "CREATE_FLIGHT_TRACKING_FAIL";

export const UPDATE_FLIGHT_TRACKING_ACTION = "UPDATE_FLIGHT_TRACKING_ACTION";
export const UPDATE_FLIGHT_TRACKING_SUCCESS = "UPDATE_FLIGHT_TRACKING_SUCCESS";
export const UPDATE_FLIGHT_TRACKING_FAIL = "UPDATE_FLIGHT_TRACKING_FAIL";

export const DELETE_FLIGHT_TRACKING_ACTION = "DELETE_FLIGHT_TRACKING_ACTION";
export const DELETE_FLIGHT_TRACKING_SUCCESS = "DELETE_FLIGHT_TRACKING_SUCCESS";
export const DELETE_FLIGHT_TRACKING_FAIL = "DELETE_FLIGHT_TRACKING_FAIL";

export const GET_ALL_FLIGHT_TRACKING_ORDER_ACTION = "GET_ALL_FLIGHT_TRACKING_ORDER";
export const GET_ALL_FLIGHT_TRACKING_ORDER_SUCCESS = "GET_ALL_FLIGHT_TRACKING_ORDER_SUCCESS";
export const GET_ALL_FLIGHT_TRACKING_ORDER_FAIL = "GET_ALL_FLIGHT_TRACKING_ORDER_FAIL";

export const AFFILIATE_REPUSH_ACTION = "AFFILIATE_REPUSH_ACTION";
export const AFFILIATE_REPUSH_SUCCESS = "AFFILIATE_REPUSH_SUCCESS";
export const AFFILIATE_REPUSH_FAIL = "AFFILIATE_REPUSH_FAIL";

export const POINT_HISTORIES_ACTION = "POINT_HISTORIES_ACTION";
export const POINT_HISTORIES_SUCCESS = "POINT_HISTORIES_SUCCESS";
export const POINT_HISTORIES_FAIL = "POINT_HISTORIES_FAIL";

export const REFUND_ORDER_POINT_ACTION = "REFUND_ORDER_POINT_ACTION";
export const REFUND_ORDER_POINT_SUCCESS = "REFUND_ORDER_POINT_SUCCESS";
export const REFUND_ORDER_POINT_FAIL = "REFUND_ORDER_POINT_FAIL";
